// extracted by css-extract-rspack-plugin
export default {"icon":"header-fragment__Icon_icon__Wj21E"};